import {
	FormControl,
	MenuItem,
	Select,
	SelectChangeEvent,
} from "@mui/material";
import { Organization } from "../../types/model";

interface OrganizationSwitcherProps {
	organizations: Organization[];
	activeOrganization: string;
	onChangeOrganization: (id: string) => void;
}

export default function OrganizationSwitcherUI(props: OrganizationSwitcherProps) {
	const handleChange = (event: SelectChangeEvent) => {
		const id = event.target.value;
		props.onChangeOrganization(id);
	};

	const menuList = props.organizations.map((organization) => (
				<MenuItem key={organization.organization_id} value={organization.organization_id}>{organization.name}</MenuItem>
		))

	return (
		<>
			<FormControl 
				fullWidth variant="standard" 
			>
				<Select
					value={props.activeOrganization}
					onChange={handleChange}
				>
					{menuList}
				</Select>
			</FormControl>
		</>
	);
}
